export default __webpack_public_path__ + "static/media/pending-post.96097f73.svg";